export default __webpack_public_path__ + "static/media/DAIF_UseCase_Clean.773811ec.jpg";